import React,{useEffect,useState} from 'react';
import {Image} from 'antd';
import NavBar from "./NavBar";
import {observer} from "mobx-react";
import {useTranslation} from "react-i18next";
import store from "./store";
import history from "../../libs/history";

import './index.less'

import fwbz2 from './images/fwbz2.png'
import fwbz2_en from './images/fwbz2_en.png'
import fwbz3 from './images/fwbz3.png'
import fwbz3_en from './images/fwbz3_en.png'
import home from './images/home.png'
import zllc1 from './images/zllc1.png'
import zllc1_en from './images/zllc1_en.png'
import zllc2 from './images/zllc2.png'
import zllc2_en from './images/zllc2_en.png'
import zzws from './images/微松冷链授权资质.jpg'
import zzakm from './images/澳柯玛授权资质.jpg'
import zzby from './images/白洋医疗授权资质.jpg'

export default observer(function () {
  const {i18n} = useTranslation();// {t('')}
  const {showItemId} = store
  useEffect(()=>{
    if (history.location.search) {
      store.showItemId = history.location.search.split('=')[1];
    }
    console.log(history.location.search,'history.location');
  },[history.location])

  return (
    <div id="QA">
      {
        i18n.language === 'zh' ? (
          <div>
            {/* <div className="title">
              <div className="inner">
                <img className="homeIcon" src={home}/>
                <span>常见问题</span>
              </div>
            </div> */}
            <div className="content clearfix">
              <NavBar/>
              {
                showItemId === 'cjwt' ? (
                  <div className="right cjwt">
                     {/* <h2>常见问题</h2> */}
                    <div>
                      <div className='question_container'>
                        <p className="bold">Q：设备的采购和租赁有什么主要区别？</p>
                        <p>A：采购属于交易完成后是贵司的资产，贵司有支配权。租赁属于我司的资产，需要贵司到期后归还。</p>
                      </div>
                      <div className='question_container'>
                        <p className="bold">Q：在你们这里购买设备和其他地方购买，有什么区别？</p>
                        <p>A：设备本身没有区别。同时我司会为设备提供完善的增值服务，包括备库、就位拆箱、定期计量、设备流转、回收、资产管理盘点等。</p>
                      </div>
                      <div className='question_container'>
                        <p className="bold">Q：租赁设备的质量如何保证？</p>
                        <p>
                          A：
                          <span>1.	我们的设备出库前会进行性能测试，保证设备是在运行状态良好的情况下发货。<br/></span>
                          <span className="marginL28">2.	在库设备，我们自有工程师会进行定期检查和维护。<br/></span>
                          <span className="marginL28">3.	如果设备发生一类故障，我司自有工程师会进行初判，并由原厂工程师协同维修。若遇重大故障，我们会补发在库设备更替使用。</span>
                        </p>
                      </div>
                      <div className='question_container'>
                      <p className="bold">Q：什么是定期计量服务？</p>
                      <p>A：客户在我司购买/租赁的设备，由在线管理系统自动提醒证书到期日，我们会及时安排计量、更新证书。</p>
                      </div>
                      <div className='question_container'>
                        <p className="bold">Q：租赁的设备，在使用中发生故障。</p>
                        <p>
                          A：
                          <span>1.	我们的工程师会根据故障的情况进行远程指导排除小问题，若无法解决会及时安排上门检修。<br/></span>
                          <span className="marginL28">2.	如设备故障无法修复，我们会重新发送替换设备。</span>
                        </p>
                      </div>
                      <div className='question_container'>
                        <p className="bold">Q：我想购买/租赁的设备，但网站上没有。</p>
                        <p>
                          A：您可以联系我们的销售顾问或者客服人员进行沟通，我们承诺会在2个小时内给您答复。<br/>
                          在数量达到一定的情况下，同样也能提供备库服务。
                        </p>
                      </div>
                      <div className='question_container'>
                        <p className="bold">Q：设备租用到期快递费用由谁承担？</p>
                        <p>A：设备租用到期的快递费用由我司承担。</p>
                      </div>
                    </div>
                   </div>
                ) : showItemId === 'zllc' ? (
                  <div className="right zllc">
                    <h2>租赁流程</h2>
                    <div>
                      <p><Image src={zllc1}/></p>
                      <p><Image src={zllc2}/></p>
                    </div>
                  </div>
                ) : showItemId === 'zjzf' ? (
                  <div className="right zjzf">
                    <h2>租金支付</h2>
                    <div>
                      <p>1.押金收取：于首付租金支付时收取（符合免押金客户除外）。</p>
                      <p>2.新订单首期租金在确认收货后支付。首期支付不得少于一年的租赁费用。</p>
                      <p>3.确认收货后，客户收到发票按照协议账期支付。</p>
                      <p>4.支付方式：对公转账。</p>
                    </div>
                  </div>
                ) : showItemId === 'kpsm' ? (
                  <div className="right kpsm">
                    <h2>开票说明</h2>
                    <div>
                      <p>1.可开票项：租赁服务、运费、技术服务费(设备押金不支持开票）。</p>
                      <p>2.发票内容可为：租赁服务费、技术服务费(视具体发生事项)。</p>
                      <p>3.发票类型为：增值税专用发票。</p>
                      <p>4.税率：租赁服务费（13%税率）、技术服务费（6%税率）。</p>
                    </div>
                  </div>
                ) : showItemId === 'fwbz' ? (
                  <div className="right fwbz">
                    <h2>服务标准</h2>
                    <div>
                      <p className="bold">客户报修方式</p>
                      <p>1、全国统一服务热线报修：400-086-5292，专属线上服务工程师在线服务。</p>
                      <p>2、在线一键报修：登录泉心泉意临床网站，在一键报修界面点击在线客服进行预约。</p>
                      <p>3、服务查询：可通过400-086-5292查询服务进度。</p>
                      <p className="bold">《设备保修标准》</p>
                      <div>
                        <table border="1" cellSpacing="0">
                          <tr>
                            <td className="backgroundf5" width="150px">硬件故障保修方式</td>
                            <td className="backgroundf5 textalignl">保修标准</td>
                            <td className="backgroundf5" width="150px">特别说明</td>
                          </tr>
                          <tr>
                            <td className="backgroundf5">标准保修</td>
                            <td
                              className="textalignl">设备正常使用情况下出现的故障（不包含摔碎、磕碰、雷击等人为或外力因素造成的外壳、屏幕及电子部件损坏等故障），由专业技术人员进行电话、网络排障，不能进行电话、网络排障的提供市内第二个工作日内上门服务，省市外由双方商议决定。
                            </td>
                            <td rowSpan="3">我司只针对设备硬件进行保修，软件及数据问题不在我司服务范围之内，也无任何责任或义务保障客户软件及数据安全，请客户自行做好数据备份工作。</td>
                          </tr>
                          <tr>
                            <td className="backgroundf5">换机维修</td>
                            <td className="textalignl">
                              <p>1、同一个设备同一个备件故障，一个月内维修三次后仍无法解决，可以做换机维修操作。</p>
                              <p>2、特殊情况换机，需要经过客户与业务人员沟通后特殊申请，我司根据实际情况评估，再给与客户准确答复。</p>
                            </td>
                          </tr>
                          <tr>
                            <td className="backgroundf5">全新机保修</td>
                            <td className="textalignl">
                              <p>1、全新机保修全部按照厂商保修及服务标准执行。</p>
                              <p>2、如为租赁备库机型，遇到无法维修解决的故障，可直接换机，更换机器不保证全新机，但成色接近全新机。</p>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <p className="marginT50 bold">热线及远程服务标准</p>
                      <p className="bold">1、热线服务</p>
                      <p>• 售后服务热线：400-086-5292，专业技术工程师在线提供技术支持服务。</p>
                      <p className="bold">2、远程服务</p>
                      <p>• 泉心泉意为客户免费远程服务。客户报修设备故障，线上服务工程师首先会通过远程方式协助客户解决，更加高效的为客户解决问题。</p>
                      <p className="bold">上门服务标准</p>
                      <p>• 北京、上海、苏州区域市内1个工作日内上门维修；全国其他城市参考原厂服务时效标准。</p>
                      <p className="bold">寄修服务标准</p>
                      <p>•
                        1、如需要寄送维修或者换机维修，为方便客户使用及数据迁移，服务工程师判断设备硬件故障时，会给客户快递同型号同配置设备，客户收到设备后迁移资料后寄回仓库，保修范围内双向物流快递费用由我司承担，客户问题维修或更换物流费用由客户承担。</p>
                      <p>• 2、如客户签收我司快递替换设备后，需在5个工作日内将故障设备寄回。</p>
                      <p className="marginT50 bold">服务流程</p>
                      <p>• 《上门服务流程》</p>
                      <p><Image src={fwbz2}/></p>
                      <p className="marginT50 bold">服务流程</p>
                      <p>• 《寄修服务流程》</p>
                      <p><Image src={fwbz3}/></p>
                    </div>
                  </div>
                ) : showItemId === 'pcbz' ? (
                  <div className="right pcbz">
                    <h2>赔偿标准</h2>
                    <div>
                      <p className="bold">基本判断原则</p>
                      <p>根据标准保修服务要求：非正常损坏设备不能无条件退还，需按照设备损坏程度自行承担相应费用。</p>
                      <p className="marginT50 bold">基本判断原则如下:</p>
                      <p>1、因意外因素或人为原因，包括摔碎、磕碰、雷击等人为或外力因素等导致的设备或部件碎裂、锈蚀、损坏等。</p>
                      <p>2、未按协议约定的用途使用设备或使用不当。</p>
                      <p>3、非设备所规定的工作环境等造成的故障或损坏（例如温度过高、过低，过于潮湿或干燥，海拔过高）。</p>
                      <p>4、由非泉心授权机构和人员进行变动、修理、添改或拆卸而造成的故障或损坏。</p>
                      <p>5、因自然灾害等不可抗力（如地震、火灾、雷击等）原因造成的故障或损坏。</p>
                      <p>6、设备或配件遗失按照原值赔偿。</p>
                      <p className="marginT50 bold">备注:</p>
                      <p>设备租满一年，正常使用造成的外壳磨损油光，外壳小于2cm的划伤，外壳小于1cm的裂痕均可免责。</p>

                    </div>
                  </div>
                ) : showItemId === 'thhzc' ? (
                  <div className="right thhzc">
                    <h2>退换货政策</h2>
                    <div>
                      <p className="bold">A）可以申请退换货的情形：</p>
                      <p>1、物流原因导致的设备损坏、缺件、错件等情况的可以拒收，并拍照存证；或签收的同时要求物流公司开具证明文件；</p>
                      <p>2、交付的产品型号、规格、数量等与订单不符的；</p>
                      <p>3、产品质量问题（因不当使用等人为原因导致的除外），根据法律规定、产品质量保证等予以修理、更换、退货。</p>
                      <p>4、租赁设备发生故障无法维修好，支持同类型、同型号、同配置更换，维修期间支持免费提供替代机，维修好立即上门更换。若遇缺货情况，支持同等价值设备替代，不产生租金、押金、额度减值，服务费除外，服务费根据实际情况产生。</p>
                      <p className="marginT50 bold">B）不予退换货的情形：</p>
                      <p>1、定制、定做设备；</p>
                      <p>2、任何非我司出售的设备；</p>
                      <p>3、符合退换货标准的设备，但已无库存无法换货的，则仅能办理退货退款；</p>
                      <p>4、已过质保期的设备(租赁订单除外)；</p>
                      <p>5、因不当使用、擅自拆卸、维修、改动等人为原因或意外事件造成的设备损坏；</p>
                      <p>6、撕毁、涂改防伪码、序列号、标签等设备标识的；</p>
                      <p>7、因客户个人偏好等主观原因引起的退换货需求；</p>
                      <p>8、其他根据设备性质不适宜退货、经您在购买时已确认不宜退货的产品。</p>
                      <p className="marginT50 bold">C）退换货注意事项：</p>
                      <p>退货设备应当设备、配件、凭证及包装完好，不影响二次销售；</p>
                      <p>办理退货应当一并退回发票、赠品等；</p>
                      <p>因客户原因造成的退货，退货运费由客户承担。</p>
                    </div>
                  </div>
                ) : showItemId === 'myjzl' ? (
                  <div className="right myjzl">
                    <h2>免押金服务</h2>
                    <div>
                      <p>一、申请免押金租赁流程</p>
                      <p>申请免押金租赁：注册账户后，后台提交相关资料，我司1-2个工作日对信用状况进行认证评估审核，审核通过后即可选择设备下单。</p>
                      <p>二、免押金租赁授信资料要求</p>
                      <p>需提供公司营业执照副本复印件、企业法人身份证复印件，并加盖公章。</p>
                      <p>三、如何提高免押金授信额度</p>
                      <p>1. 系统会不定期重新进行信用评估，如您的信用记录保持良好，系统会定期提高您的免押金授信额度。</p>
                      <p>2. 提供下述任意一项资料即可有助于提高您的免押金授信额度：</p>
                      <p>2.1、经营场所租赁合同</p>
                      <p>资料要求：</p>
                      <p>1）租赁合同内容应包含：双方单位名称、联系人、单位地址、租赁起止时间、租赁面积、租赁价格、双方签名、日期、双方盖章；</p>
                      <p>2）有效期内租赁时长不低于6个月；</p>
                      <p>3）租赁地址与实际经营地址完全一致；</p>
                      <p>4）签订人为公司法人或股东；其他人签订，需再附一份工作证明，证明其为本单位员工；</p>
                      <p className="marginT50">2.2、社保或公积金缴纳证明</p>
                      <p>资料要求：</p>
                      <p>1）线下：社保局查询，需盖章；</p>
                      <p>2）线上登录：http://www.12333sb.com社保查询网，查询，拍照或截图文件；（或对公银行账户对应项扣款信息截图）；</p>
                      <p>3）三方代缴，请提供双方签订的“人力资源”服务合同（合同内容应包含：双方单位名称、联系人、代缴起止期限、代缴的价格/人，双方签名、日期、双方盖章），以及每月转账凭证（加盖银行章）；</p>
                      <p className="marginT50">2.3、法人或股东征信报告</p>
                      <p>资料要求：</p>
                      <p>1）线下个人征信：个人人行查询纸质文件，必须盖有人行章（近2个月内）；</p>
                      <p>2）互联网个人征信：A、网址：http://www.pbccrc.org.cn/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;B、Pdf格式导出文件+当前页面截图或拍照件；</p>
                      <p className="marginT50">2.4、企业对公账户流水</p>
                      <p>资料要求：</p>
                      <p>1) 银行打印的对公账户近期满3个月流水纸质账单拍照件，加盖银行章（账单内容需包含：姓名、近期满3个月流水、余额、银行章）；</p>
                      <p>2) 网上查询对公账户近期满3个月流水账单拍照件（拍照内容需包含：网址、姓名、近期满3个月流水、余额）；</p>
                      <p className="marginT50">2.5、其他证明</p>
                      <p>您可提供合作/战略协议、出资证明、公司章程、验资报告等资料，我司根据实际情况为您提高免押金授信额度。</p>
                    </div>
                  </div>
                ) : showItemId === 'jl' ? (
                  <div className="right jl">
                    <h2>计量</h2>
                    <div>
                      <p className="bold">服务内容:</p>
                      <p>我司根据国家相关规程和标准对客户的仪器仪表委托计量院或第三方进行计量校准，出具计量证书。</p>
                      <p className="marginT50 bold">服务方式:</p>
                      <p>1.邮寄送检:温度记录仪、血压计、体温计、心电图机、输液泵等</p>
                      <p>2.现场校验:冰箱、培养箱、离心机、体重秤等</p>
                      <p className="marginT50 bold">服务时限:</p>
                      <p>1、常规送检业务的检测期限为10个工作日。</p>
                      <p>2、上门计量业务需要提前5个工作日预约。</p>
                      <p className="marginT50 bold">其他:</p>
                      <p>1、当送检的计量器具检测结果不合格需修理时，应征得客户同意，修理时间与客户协商，不受检测工作期限的限制。</p>
                      <p>2、邮寄送检的仪器仪表计量不合格的、退检的不收取检验费用；上门计量设备不合格时设备不收取本仪器仪表的计量费用，只收取单次交通费。</p>
                      <p className="marginT50 bold">验收标准:</p>
                      <p>1、满足所声明的国家检定规程或ISO9000、ISO17025等国际标准的要求，所出具的测试数据科学、公正、准确。</p>
                      <p>2、仪器检准完成后使用正常。</p>
                    </div>
                  </div>
                ) : showItemId === 'zcxy' ? (
                  <div className="right zcxy">
                    <h2>注册协议</h2>
                    <div>
                      <p><span className="paddingL33">本协议是泉心泉意(上海)生命科技有限公司(以下简称“Lab Direct”)官方网站（www.lab-direct.com/，以下称为“本网站”）与用户（以下称为“您”）共同缔结的对双方具有约束力的有效契约。</span>
                      </p>
                      <p><span className="paddingL33">鉴于Lab Direct在本网站上向用户展示的产品和服务随时可能会更新，而Lab Direct无法向全体用户点对点推送最新的产品和服务内容，因此，Lab Direct提供的产品和服务，以本网站相关页面最新展示的内容或双方依法签署并在有效期内的协议/合同/订单约定的内容为准。</span>
                      </p>
                      <p><span
                        className="paddingL33">您在使用本网站的服务之前，已经充分阅读、理解并接受本服务条款的全部内容，一旦您选择“同意”并完成注册流程或使用本网站之服务，即表示您同意遵循本协议之所有约定。</span>
                      </p>
                      <p><span className="paddingL33 bold">第一条 关于账户</span></p>
                      <p><span className="paddingL33">一．在您完成注册程序或以其他Lab Direct允许的方式实际使用本服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。</span>
                      </p>
                      <p><span className="paddingL33">二．您应当准确填写并及时更新您提供的联系电话等联系方式，以便Lab Direct与您进行有效联系，因通过这些联系方式无法与您取得联系，导致您在使用Lab Direct服务过程中产生任何损失或增加费用的，应由您完全独自承担。您了解并同意，您有义务保持您提供的联系方式的有效性，如有变更需要更新的，您应按Lab Direct的要求进行操作。</span>
                      </p>
                      <p><span className="paddingL33">三．您须自行负责对您的Lab Direct账户和密码保密，且须对您在该登录名和密码下发生的所有活动（包括但不限于信息披露、发布信息、网上点击同意或提交各类规则协议、网上续签协议或购买服务等）承担责任。您同意：(1)如发现任何人未经授权使用您的Lab Direct账户和密码，或发生违反保密规定的任何其他情况，您会立即通知Lab Direct，并授权Lab Direct对您的账户采取保护措施；(2)确保您在每个上网时段结束时，以正确步骤离开网站。Lab Direct不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。您理解Lab Direct对您的请求采取行动需要合理时间，Lab Direct对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。</span>
                      </p>
                      <p><span className="paddingL33">四．Lab Direct有权了解您使用本网站产品及服务的真实背景及目的，有权要求您如实提供真实、全面、准确的信息；如果Lab Direct有合理理由怀疑您提供的信息不真实、您进行虚假交易，或您的行为违反Lab Direct的网站规则的，Lab Direct有权暂时或永久限制您账户下所使用的所有产品及/或服务的部分或全部功能。</span>
                      </p>
                      <p><span className="paddingL33 bold">第二条 网站服务使用守则</span></p>
                      <p><span className="paddingL33">为有效保障您使用本服务的合法权益，您理解并同意接受以下规则：</span></p>
                      <p><span className="paddingL33">一．您通过包括但不限于以下方式向Lab Direct发出的指令，均视为您本人的指令，不可撤回或撤销，您应自行对Lab Direct执行前述指令所产生的任何结果承担责任：</span>
                      </p>
                      <p><span className="paddingL33">1.通过您的Lab Direct账户和密码进行的所有操作。</span></p>
                      <p><span className="paddingL33">2.通过与您的账户绑定的手机号码向Lab Direct发送的全部信息。</span></p>
                      <p><span className="paddingL33">3.其他Lab Direct与您约定的其他方式。</span></p>
                      <p><span className="paddingL33">二．您在使用本服务过程中，本服务条款内容、页面上出现的关于交易操作的提示或Lab Direct发送到您手机的信息（短信或电话等）内容是您使用本服务的相关规则，您使用本服务即表示您同意接受本服务的相关规则。</span>
                      </p>
                      <p><span className="paddingL33">三．在您开始使用Lab Direct的某一产品或服务前，可能需要与Lab Direct就这一产品或服务签订单独的服务协议。您只有在接受该服务协议的全部内容后方可使用该产品或服务；如您不同意该服务协议的部分或者全部的，请您不要进行后续操作。</span>
                      </p>
                      <p><span className="paddingL33 bold">第三条 订单及配送</span></p>
                      <p><span
                        className="paddingL33">一．在您提交订单时，请您仔细确认所提交订单中商品或服务的名称、价格、数量、型号、规格、联系地址、电话、收货人等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。</span>
                      </p>
                      <p><span className="paddingL33">二．Lab Direct或合作的第三方将会把商品（货物）送到您所指定的收货地址，所有在本站上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点等相关信息估计得出的。</span>
                      </p>
                      <p><span className="paddingL33">三．如货物或/和服务在交付期间发生包括但不限于泥石流、山体滑坡、火山爆发等不可抗力的自然灾害，或者出现包括但不限于未经预告的交通管制、油料缺货、战争、武装冲突、大面积的示威游行、承运车辆发生自燃/抛锚/损毁、地址错误或不详、货物送达后无人签收、收货地址限制送货车辆进入、等不可事先预知的事件，并最终导致Lab Direct延迟交付货物或/和服务，您承诺放弃因上述原因向Lab Direct主张赔偿或/和要求Lab Direct承担相关责任的权利。</span>
                      </p>
                      <p><span className="paddingL33 bold">第四条 您的权利和义务</span></p>
                      <p><span className="paddingL33">一．您有权利享受Lab Direct提供的技术和信息服务，并有权利在接受Lab Direct提供的服务时获得Lab Direct的技术支持、咨询等服务，服务内容详见本网站相关产品介绍。</span>
                      </p>
                      <p><span className="paddingL33">二．您保证不会利用技术或其他手段破坏或扰乱本网站。</span></p>
                      <p><span className="paddingL33">三．您使用Lab Direct的产品或服务时必须遵从国家法律、地方法规、行业惯例和社会公共道德，不会利用Lab Direct提供的产品或/和服务进行存储、发布、传播如下信息和内容，同时承诺不得为他人发布下述不符合国家规定和/或本服务条款约定的信息内容提供任何便利。</span>
                      </p>
                      <p><span className="paddingL33">1.违反国家法律法规政策的任何内容（信息）。</span></p>
                      <p><span className="paddingL33">2.违反国家规定的政治宣传和/或新闻信息。</span></p>
                      <p><span className="paddingL33">3.涉及国家秘密和/或安全的信息。</span></p>
                      <p><span className="paddingL33">4.封建迷信和/或淫秽、色情、下流的信息或教唆犯罪的信息。</span></p>
                      <p><span className="paddingL33">5.博彩有奖、赌博游戏。</span></p>
                      <p><span className="paddingL33">6.违反国家民族和宗教政策的信息。</span></p>
                      <p><span className="paddingL33">7.妨碍互联网运行安全的信息。</span></p>
                      <p><span className="paddingL33">8.侵害他人合法权益的信息和/或其他有损于社会秩序、社会治安、公共道德的信息或内容。</span></p>
                      <p><span className="paddingL33 bold">第五条 Lab Direct的权利和义务</span></p>
                      <p><span className="paddingL33">Lab Direct应根据您选择的服务以及交纳款项的情况向您提供合格的技术和信息服务。Lab Direct承诺对您提供的资料采取对外保密措施，不向第三方披露、不授权第三方使用您的资料，除非出现以下所述的任一情况：</span>
                      </p>
                      <p><span className="paddingL33">1.依据本服务条款或者您与Lab Direct之间其他服务协议、合同、在线条款等规定可以提供。</span></p>
                      <p><span className="paddingL33">2.依据法律法规的规定应当提供。</span></p>
                      <p><span className="paddingL33">3.行政、司法等职权部门要求Lab Direct依法提供。</span></p>
                      <p><span className="paddingL33">4.Lab Direct之股东、投资人、相关利益权益人要求Lab Direct提供。</span></p>
                      <p><span className="paddingL33">5.您同意Lab Direct向第三方提供。</span></p>
                      <p><span className="paddingL33">6.Lab Direct解决举报事件、提起诉讼而提交的。</span></p>
                      <p><span className="paddingL33">7.Lab Direct为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的。</span></p>
                      <p><span className="paddingL33">8.Lab Direct为向您提供产品、服务、信息而向第三方提供的，包括Lab Direct通过第三方的技术及服务向您提供产品、服务、信息的情况。</span>
                      </p>
                      <p><span className="paddingL33 bold">第六条 协议更新、生效和履行</span></p>
                      <p><span className="paddingL33">一．根据国家法律法规变化及网站运营需要，Lab Direct有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本网站上便即刻生效，并代替原来的协议。</span>
                      </p>
                      <p><span className="paddingL33">二．本网站服务条款一旦发生变动，将会在重要页面上提示修改内容。如您不同意更新后的协议，可以且应立即停止接受本网站依据本协议提供的服务；如您继续使用本网站提供的服务的，即视为同意更新后的协议。Lab Direct建议您在使用本站之前阅读本协议及本站的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</span>
                      </p>
                      <p><span className="paddingL33 bold">第七条 信息内容的所有权</span></p>
                      <p><span
                        className="paddingL33">本网站定义的信息内容包括：文字、软件、声音、相片、录象、图表；在广告中全部内容；本网站为用户提供的其它信息。所有这些内容受版权、商标、标签和其它财产所有权法律的保护。所以，用户只能在本网站和广告商授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。</span>
                      </p>
                      <p><span className="paddingL33 bold">第八条 法律适用与管辖</span></p>
                      <p><span
                        className="paddingL33">本网站信息服务条款要与中华人民共和国的法律解释一致。用户和本网站一致同意服从本网站所在地有管辖权的法院管辖。如发生本网站服务条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款则依旧保持对用户的约束力。</span>
                      </p>
                    </div>
                  </div>
                ) : showItemId === 'qyfwzz' ? (
                  <div className="right qyfwzz">
                    <h2>企业服务资质</h2>
                    <div className="clearfix">
                      <div className="cell">
                        <Image src={zzws}/>
                        <span>微松冷链授权资质</span>
                      </div>
                      <div className="cell">
                        <Image src={zzakm}/>
                        <span>澳柯玛授权资质</span>
                      </div>
                      <div className="cell">
                        <Image src={zzby}/>
                        <span>白洋医疗授权资质</span>
                      </div>
                    </div>
                  </div>
                ) : null
              }
            </div>
          </div>
        ) : (
          <div>
            <div className="title">
              <div className="inner">
                <Image className="homeIcon" src={home}/>
                <span>FAQ</span>
              </div>
            </div>
            <div className="content clearfix">
              <NavBar/>
              {
                showItemId === 'cjwt' ? (
                  <div className="right cjwt">
                    <h2>FAQ</h2>
                    <div>
                      <p className="bold">Q: What is the main difference between equipment procurement and leasing?</p>
                      <p>A: Procured equipment becomes your company’s asset after the transaction. Leased equipment is
                        still
                        this company’s asset and to be returned when the lease expires.</p>
                      <p className="marginT50 bold">Q: What is the difference between buying equipment here and buying
                        it
                        elsewhere?</p>
                      <p>A: The equipment is the same. However, this company provides complete value-added services for
                        the
                        equipment, including inventory preparation, unpacking in place, regular measurement, equipment
                        circulation, recycling, and asset management & inventory.</p>
                      <p className="marginT50 bold">Q: How to guarantee the quality of rental equipment?</p>
                      <p>
                        A：
                        <span>1. Our equipment will be tested for performance before delivery to ensure that it is shipped in good condition.<br/></span>
                        <span className="marginL28">2.Our own engineers will carry out regular inspection on equipment in the warehouse and maintenance.<br/></span>
                        <span className="marginL28">3. For Class-A failure of equipment, our own engineers will make a preliminary judgment, and the original factory engineers will coordinate with to repair. In the event of a major failure, we will replenish and dispatch equipment in the warehouse for replacement.</span>
                      </p>
                      <p className="marginT50 bold">Q：What regular measurement service refers to?</p>
                      <p>A: The online management system will automatically remind the expiration date of certificate
                        for
                        equipment purchased/leased by customers, and we will arrange measurement and update the
                        certificate
                        in time.</p>
                      <p className="marginT50 bold">Q: The leased equipment fails during use.</p>
                      <p>
                        A：
                        <span>1. Our engineers will perform remote guidance to solve minor problems according to the situation, and if the failure remains, we will promptly arrange for on-site maintenance.<br/></span>
                        <span className="marginL28">2. If the equipment failure cannot be repaired, we will dispatch equipment for replacement.</span>
                      </p>
                      <p className="marginT50 bold">Q: The equipment I want to buy/rent is unavailable on the
                        website.</p>
                      <p>
                        A: You can contact our sales consultant or customer service staff, and we promise to reply to
                        you
                        within 2 hours.<br/>
                        When the quantity reaches a certain level, we will provide re-stocking services.
                      </p>
                      <p className="marginT50 bold">Q: Who will bear the courier expenses when the lease expires?</p>
                      <p>A: Our company shall bear the courier expenses for expiration of lease.</p>
                    </div>
                  </div>
                ) : showItemId === 'zllc' ? (
                  <div className="right zllc">
                    <h2>Rental Procedure</h2>
                    <div>
                      <p><Image src={zllc1_en}/></p>
                      <p><Image src={zllc2_en}/></p>
                    </div>
                  </div>
                ) : showItemId === 'zjzf' ? (
                  <div className="right zjzf">
                    <h2>Rent Payment</h2>
                    <div>
                      <p>1. Deposit collection: collected when the down payment is paid (except for deposit-free
                        customers).</p>
                      <p>2. The down payment of new orders is paid after the receipt of the goods is confirmed. The down
                        payment shall not be less than one year’s rental.</p>
                      <p>3. Customers will receive the invoice and pay according to the agreed accounting period after
                        receipt is confirmed.</p>
                      <p>4. Payment: public transfer.</p>
                    </div>
                  </div>
                ) : showItemId === 'kpsm' ? (
                  <div className="right kpsm">
                    <h2>Description of Making Invoice</h2>
                    <div>
                      <p>1. Invoiceable items: rental service, freight, technical service fee (Equipment deposit is
                        beyond
                        the scope of invoicing).</p>
                      <p>2. The content of invoice covers: rental service fee, technical service fee (depending on the
                        specific situation).</p>
                      <p>3. The invoice type: special value-added tax invoice.</p>
                      <p>4. Tax rate: rental service fee (13% tax rate), technical service fee (6% tax rate).</p>
                    </div>
                  </div>
                ) : showItemId === 'fwbz' ? (
                  <div className="right fwbz">
                    <h2>Service Standard</h2>
                    <div>
                      <p className="bold">Way of Requesting for Repair</p>
                      <p>1. National uniform service hotline: 400-086-5292, online service provided by dedicated
                        online-service engineers.</p>
                      <p>2. Online one-click requesting for repair: Log in to the clinical website of Lab Direct, and
                        click
                        on the online customer service on the one-click requesting for repair interface to make an
                        appointment.</p>
                      <p>3. Service inquiry: service progress can be inquired by dealing 400-086-5292.</p>
                      <p className="bold">“Equipment Warranty Standard”</p>
                      <div>
                        <table border="1" cellSpacing="0">
                          <tr>
                            <td className="backgroundf5" width="150px">Hardware failure warranty</td>
                            <td className="backgroundf5 textalignl">Warranty standard</td>
                            <td className="backgroundf5" width="150px">Special instructions</td>
                          </tr>
                          <tr>
                            <td className="backgroundf5">Standard Warranty</td>
                            <td className="textalignl">For failures that occur under normal use of the equipment
                              (excluding
                              damage to the casing, screen and electronic components caused by man-made or external
                              factors
                              such as being broken, bumped, lightning strikes, etc.) professional technicians will
                              remove
                              the failures via telephone/network, otherwise they will provide door-to-door service
                              within
                              the second working day in the city, and both parties will negotiate for customers in other
                              provinces and cities.
                            </td>
                            <td rowSpan="3">This company only provides warranty for equipment hardware, and software and
                              data problems are beyond the service scope. What’s more, we are not obligated to ensure
                              the
                              safety of customer software and data, so you are requested to perform data backup
                              yourselves.
                            </td>
                          </tr>
                          <tr>
                            <td className="backgroundf5">Replacement & Maintenance</td>
                            <td className="textalignl">
                              <p>1. If the failure of the same equipment and the same spare part can not be solved after
                                being repaired three times within a month, the equipment can be replaced to
                                maintain.</p>
                              <p>2. For replacement under special circumstances, special application is required after
                                communication with sales personnel. This company will evaluate according to the fact and
                                then gives an accurate answer.</p>
                            </td>
                          </tr>
                          <tr>
                            <td className="backgroundf5">Brand New Equipment Warranty</td>
                            <td className="textalignl">
                              <p>1. The warranty for new equipment is all implemented in accordance with the
                                manufacturer’s
                                warranty and service standards.</p>
                              <p>2. For failure of a leased standby model that cannot be repaired, the equipment can be
                                replaced directly. The replacing equipment may not be a new one, but its quality is
                                close to
                                new.</p>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <p className="marginT50 bold">Hotline and Remote Service Standards</p>
                      <p className="bold">1. Hotline Service</p>
                      <p>• After-sales service hotline: 400-086-5292, online service provided by dedicated online-service
                        engineers.</p>
                      <p className="bold">2. Remote Service</p>
                      <p>• Lab Direct provides free remote service for customers. If customers report equipment
                        failures,
                        online service engineers will first assist customers in solving problems remotely to improve the
                        efficiently of service.</p>
                      <p className="bold">Door-to-door Service Standards</p>
                      <p>• Door-to-door maintenance will be provided within 1 working day in Beijing, Shanghai, and
                        Suzhou;
                        other cities across China refer to the service timeliness standards of the original factory.</p>
                      <p className="bold">Standards of Send-To-Repair Service</p>
                      <p>• 1. If equipment is needed to be sent for repair or replacement for maintenance, our service
                        engineer will send equipment of the same model and configuration to the customer by express when
                        judging hardware failure, so as to facilitate use and data migration. The migration data will be
                        sent back to the warehouse after the customer receives the equipment, and the cost of two-way
                        logistics within the scope of warranty is borne by this company, and the logistics cost of
                        repair or
                        replacement due to the customer is borne by the customer.</p>
                      <p>• 2. After the customer signs for the replacement equipment delivered by the company, the
                        faulty
                        equipment must be returned within 5 working days.</p>
                      <p className="marginT50 bold">Service Process</p>
                      <p>• “Door-to-door Service Process”</p>
                      <p><Image src={fwbz2_en}/></p>
                      <p className="marginT50 bold">Service Process</p>
                      <p>• “Repair Service Process”</p>
                      <p><Image src={fwbz3_en}/></p>
                    </div>
                  </div>
                ) : showItemId === 'pcbz' ? (
                  <div className="right pcbz">
                    <h2>Compensation Standards</h2>
                    <div>
                      <p className="bold">Basic Judgment Principles</p>
                      <p>According to the standard warranty service requirements: abnormally damaged equipment cannot be
                        returned unconditionally, and the corresponding expenses shall be borne by the customer
                        according to
                        the degree of damage.</p>
                      <p className="marginT50 bold">The basic judgment principles are as follows:</p>
                      <p>1. Equipment or parts are broken, rusted, damaged due to accidental factors or man-made
                        factors,
                        including breaking, bumping, lightning strikes, etc.</p>
                      <p>2. The equipment is used improperly or not used for the purpose agreed in the agreement.</p>
                      <p>3. Failure or damage caused by working environment improper for the equipment (for example, the
                        temperature is too high, too low, too humid or dry, or the altitude is too high).</p>
                      <p>4. Failure or damage caused by changes, repairs, additions, or disassembly by institutions and
                        personnel not authorized by Lab Direct.</p>
                      <p>5. Failure or damage caused by natural disasters and other force majeure (such as earthquake,
                        fire,
                        lightning strike, etc.).</p>
                      <p>6. Loss of equipment or accessories shall be compensated according to the original value.</p>
                      <p className="marginT50 bold">Note:</p>
                      <p>If the equipment has been rented for one year, the shell is worn and shiny due to normal use,
                        scratches less than 2cm and cracks less than 1cm are exempt.</p>

                    </div>
                  </div>
                ) : showItemId === 'thhzc' ? (
                  <div className="right thhzc">
                    <h2>Return & Replacement Policies</h2>
                    <div>
                      <p className="bold">A) Circumstances under which an application for return and exchange is
                        supported:</p>
                      <p>1. For products with damage, missing and wrong delivery caused by logistics reasons, rejecting
                        and
                        taking a picture for evidence are supported; or requiring the logistics company to offer
                        supporting
                        documents at the time of signing for the product;</p>
                      <p>2. The model, specification, quantity, etc. of the delivered product are not conforming to
                        those
                        specified in the order;</p>
                      <p>3. Products with quality problems (except for those problems caused by such human-induced
                        reasons
                        as improper use) that can be repaired, replaced and returned in accordance with laws and
                        regulations
                        as well as product quality assurance.</p>
                      <p>4. If the leased equipment breaks down and fails to be repaired well, the replacement of
                        equipment
                        with the same type, model and configuration is supported. During the maintenance period, the
                        free-of-charge alternative equipment is offered and the on-site replacement shall be handled as
                        soon
                        as the equipment is well repaired. In case of short supply, the replacement of equipment of the
                        same
                        value is supported without rent, deposit and credit impairment and as for the service fee, it is
                        based on the actual situation.</p>
                      <p className="marginT50 bold">B) Circumstances under which an application for return and exchange
                        is
                        not supported:</p>
                      <p>1. Customized, custom-made equipment;</p>
                      <p>2. Any equipment that is not sold by this company;</p>
                      <p>3. For equipment that meets the standards of return and exchange but is out of stock for
                        exchange,
                        this company only offers return in full refunds;</p>
                      <p>4. Equipment that has passed the warranty period (except for lease orders);</p>
                      <p>5. Equipment damage caused by such human-induced errors as improper use, unauthorized removal,
                        repair, alteration or other accidents;</p>
                      <p>6. Tearing up or altering the equipment identification such as anti-counterfeiting codes,
                        serial
                        numbers and labels;</p>
                      <p>7. Demand for return or exchange caused by the customers’ personal preferences and other
                        subjective
                        reasons;</p>
                      <p>8. Products that are not suitable for return depending on the nature of the equipment and have
                        already been confirmed by you at the time of procurement.</p>
                      <p className="marginT50 bold">C) Notes for return and exchange:</p>
                      <p>The equipment, accessories, vouchers and packaging of the returned equipment shall be kept in
                        good
                        condition for second sales;</p>
                      <p>The invoice, giveaways, etc. shall also be returned in handling the return;</p>
                      <p>For the return caused by the customer’s reasons, the cost of return shall be borne by the
                        customer.</p>
                    </div>
                  </div>
                ) : showItemId === 'myjzl' ? (
                  <div className="right myjzl">
                    <h2>Deposit-free Service</h2>
                    <div>
                      <p>I.Procedures of Application for Deposit-free Lease</p>
                      <p>Application for deposit-free lease: submit relevant information in the background after
                        registering
                        an account, and this company will conduct an assessment review on the credit status within 1-2
                        working days. After the review is passed, you can select equipment and place an order.</p>
                      <p>II. Deposit-free Lease Credit Information Requirements</p>
                      <p>Copies of the company’s business license and the legal person’s identity card with official
                        seal.</p>
                      <p>III. How to Raise the Deposit-free Credit Line</p>
                      <p>1. The system will re-assess your credit from time to time. If your credit history is good, the
                        system will raise your deposit-free credit line regularly.</p>
                      <p>2. Providing any of the following information can help raise your deposit-free credit line:</p>
                      <p>2.1. Business Premises Lease Contract</p>
                      <p>Information Requirements:</p>
                      <p>1) The contents of the lease contract should include: the names of the units where two parties
                        working in, contact person, unit address, start and end time of lease, lease area, lease price,
                        signature of both parties, date, and seal of both parties;</p>
                      <p>2) The lease shall not be less than 6 months during the validity period;</p>
                      <p>3) The leased address is exactly the same as the actual business address;</p>
                      <p>4) The signatory is the company’s legal person or shareholder; other person must sign with a
                        work
                        certificate to prove that he/she is an employee of the unit;</p>
                      <p className="marginT50">2.2, Social Security or Provident Fund Payment Certificate</p>
                      <p>Information Requirements:</p>
                      <p>1) Offline: seal is required for inquiring information from the Social Security Bureau;</p>
                      <p>2) Online login: http://www.12333sb.com for social security inquiry, query, taking photos or
                        screenshot files; (or screenshots of money deduction information for public bank accounts);</p>
                      <p>3) Three-party payment, please provide the "Human Resources" Service Contract signed by both
                        parties (the content should include: the names of the units where two parties working in, the
                        contact person, start and end time of payment on behalf, the price/payer, the signatures of both
                        parties, date, and seals of both parties), and monthly transfer voucher (with bank seal);</p>
                      <p className="marginT50">2.3. Legal Person or Shareholder Credit Report</p>
                      <p>Information Requirements:</p>
                      <p>1) Offline personal credit investigation: paper documents of inquiring from the People’s Bank
                        of
                        China must be stamped by the bank (within the past 2 months);</p>
                      <p>2) Internet personal credit investigation: A. Website:
                        http://www.pbccrc.org.cn/ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;B. Export file in Pdf format +
                        screenshot or photo of current page;</p>
                      <p className="marginT50">2.4. Business-to-Public Account Turnover</p>
                      <p>Information Requirements:</p>
                      <p>1) A photo of paper account statement bill printed by the bank for the recent 3 months of the
                        corporate account, stamped with the bank seal (the bill content must include: name, account
                        statement of the recent 3 months, balance, bank seal);</p>
                      <p>2) Photo of online inquiry of the recent 3 months’ account statement bill of the corporate
                        account
                        (photographed content should include: URL, name, account statement of the recent 3 months,
                        balance);</p>
                      <p className="marginT50">2.5. Other supporting documents</p>
                      <p>You are supposed to provide the Cooperation/Strategic Agreement, Proof of Capital Contribution,
                        Articles of Association, Capital Verification Report and this company increases the deposit-free
                        credit line for you based on the actual situation.</p>
                    </div>
                  </div>
                ) : showItemId === 'jl' ? (
                  <div className="right jl">
                    <h2>Measurement</h2>
                    <div>
                      <p className="bold">Service Content:</p>
                      <p>This company entrusts Metrology Institute or third party to carry out the calibration of the
                        customer’s instrumentation and issue metrology certificate according to national relevant
                        regulations and standards.</p>
                      <p className="marginT50 bold">Mode of Service:</p>
                      <p>1. Mail for inspection: temperature recorder, blood pressure meter, thermometer,
                        electrocardiograph, infusion pump, etc.</p>
                      <p>2. Field calibration: refrigerators, incubator, centrifuges, scales, etc.</p>
                      <p className="marginT50 bold">Period of Service:</p>
                      <p>1. The period of routine inspection service is ten working days.</p>
                      <p>2. An appointment shall be made for the on-site measurement service five working days in
                        advance.</p>
                      <p className="marginT50 bold">Others:</p>
                      <p>1. If the result of the measuring instrumentation submitted to the inspection test is not up to
                        standard and needs to be repaired, the customer’s consent shall be obtained to determine the
                        repair
                        time without any limitations of the duration of inspection.</p>
                      <p>2. If the measurement of the instrumentation mailed for inspection is not up to standard or the
                        instrumentation is returned for inspection, no inspection fee shall be charged; if the on-site
                        measurement of equipment is not up to standard, no measurement fee shall be charged for the
                        instrumentation while only a single transportation fee shall be charged.</p>
                      <p className="marginT50 bold">Acceptance Criteria:</p>
                      <p>1. The test data issued are scientific, fair and accurate to meet the requirements of the
                        stated
                        National Verification Regulations or such international standards as ISO9000 and ISO17025.</p>
                      <p>2. The instrument is in good working condition after calibration.</p>
                    </div>
                  </div>
                ) : showItemId === 'zcxy' ? (
                  <div className="right zcxy">
                    <h2>Registration Agreement</h2>
                    <div>
                      <p><span className="paddingL33">This Agreement is a valid binding contract between the official website (www.lab-direct.com/, thereinafter referred to as "this Website") of Lab Direct (Shanghai) Life Technology Co., Ltd. (thereinafter referred to as "Lab Direct”) and the user (hereinafter referred to as "you").</span>
                      </p>
                      <p><span className="paddingL33">Since the products and services that Lab Direct presents to users on this Website may be updated at any time and Lab Direct is unable to push the latest product and service content from point to point to all users, the products and services offered by Lab Direct are subject to the latest information on the relevant pages of this Website or to the content agreed upon in the terms and conditions of the agreement/contract/order signed by both parties in accordance with the law and within the validity period.</span>
                      </p>
                      <p><span className="paddingL33">You are supposed to have fully read, understood and accepted the full contents of these terms of service prior to using the services of this Website, and once you have opted the "agree" and completed the registration process or used the services of this Website, it means that you agree to abide by all the terms of this Agreement.</span>
                      </p>
                      <p><span className="paddingL33 bold">Article I About Accounts</span></p>
                      <p><span className="paddingL33">I. You are supposed to be a natural person, legal person or other organization with full civil rights and full civil capacity when you complete the registration process or actually use the service in a manner permitted by Lab Direct.</span>
                      </p>
                      <p><span className="paddingL33">II. You are supposed to fill in and update such contact details as the contact numbers in accuracy and in a timely manner so that Lab Direct can contact you effectively. You shall be solely responsible for any loss or increase in costs in using the service of Lab Direct due to the failure to get in touch with you through these contact details you have provided. You understand and agree that you are obliged to maintain the validity of the contact information you provide, and follow the requirements of Lab Direct in updating any changes.</span>
                      </p>
                      <p><span className="paddingL33">III. You are supposed to be solely responsible for keeping your Lab Direct account and password confidential and for all activities that happen under that login and password (including but not limited to, disclosing information, releasing information, clicking to agree online or submitting various rule agreements, online renewal agreements or purchases of services). You agree: (1) if you discover that anyone has unauthorized access to your Lab Direct account and password, or any other breach of confidentiality, you will immediately notify Lab Direct and authorize Lab Direct to take measures to protect your account; (2) You are supposed to log out this Website with the correct steps at the end of each Internet hour. Lab Direct cannot and shall not be responsible for any loss or damage caused by your failure to comply with the provisions under this Article. You understand that Lab Direct needs to take reasonable time to act on your request and Lab Direct shall not be responsible for any consequences that have occurred before the action is taken (including but not limited to any losses of you).</span>
                      </p>
                      <p><span className="paddingL33">IV. Lab Direct is entitled to know the true background and purpose of your use of the products and services in this Website and to request you to provide truthful, comprehensive and accurate information; and Lab Direct is entitled to temporarily or permanently restrict some or all of the functions of the products and/or services used under your account if Lab Direct has reasonable grounds to suspect that the information you provide is untrue, that you made a false transaction, or that your actions violate the rules of this Website under Lab Direct.</span>
                      </p>
                      <p><span
                        className="paddingL33 bold">Article II Code of Practice for the Use of Website Services</span>
                      </p>
                      <p><span className="paddingL33">To effectively protect your legitimate interest in using the service, you understand and agree to follow the rules below:</span>
                      </p>
                      <p><span className="paddingL33">I. Any instructions you have sent to Lab Direct, including but not limited to the following ways, shall be deemed to be your own instructions, which are irrevocable or irreversible, and you shall be liable for any consequences arising from the execution of such instructions by Lab Direct:</span>
                      </p>
                      <p><span
                        className="paddingL33">1. All actions taken through your Lab Direct account and password.</span>
                      </p>
                      <p><span className="paddingL33">2. All information sent to Lab Direct via a mobile phone number bound to your account.</span>
                      </p>
                      <p><span className="paddingL33">3. Other ways agreed upon between you and Lab Direct.</span></p>
                      <p><span className="paddingL33">II. In the course of your use of the service, the contents of these terms of service, prompts on trading operations that appear on the page, or information (SMS or phone calls) sent to your mobile phone by Lab Direct are the relevant rules for your use of the service, and your use of the service means that you agree to follow the rules for the service.</span>
                      </p>
                      <p><span className="paddingL33">III. Before you start using a product or service provided by Lab Direct, you are required to enter into a separate service agreement with Lab Direct for that product or service. You may use the product or service only if you accept the full content of the service agreement; if you do not agree with some or all of the contents of the service agreement, please do not carry out the follow-up operations.</span>
                      </p>
                      <p><span className="paddingL33 bold">Article III Order and Delivery</span></p>
                      <p><span className="paddingL33">I. When you submit an order, please carefully confirm the name, price, quantity, model, specification, contact address, phone number, consignee and other information of the products or services in the submitted order. If the information of the consignee is inconsistent with that of you, the consignee's conduct and declaration of intention shall be regarded as your conduct and declaration of intention, and you shall be jointly and severally liable for the legal consequences of the consignee's conduct and declaration of intention.</span>
                      </p>
                      <p><span className="paddingL33">II. Lab Direct or a third-party partner will deliver the goods (products) to your designated delivery address. All the delivery time listed on this Website is reference time and the calculation of which is based on the estimation of the inventory status, the normal process and delivery time, delivery address and other relevant information.</span>
                      </p>
                      <p><span className="paddingL33">III. Where the late delivery of goods and/or services by Lab Direct occur due to the fact that products and/or services are delivered in the event of a natural disaster including but not limited to mudslides, landslides, volcanic eruptions, etc., or in the event of unforeseen events, including but not limited to unforeseen traffic control, shortage of fuel, war, armed conflict, large-scale demonstrations, spontaneous combustion/breakdown/damage of the carrier vehicle, incorrect or unknown address, failure to sign for products, restricted access for delivery vehicle to the delivery address, etc., you undertake to waive your right to claim compensation and/or liability from Lab Direct for the above reasons.</span>
                      </p>
                      <p><span className="paddingL33 bold">Article IV Your Rights and Obligations</span></p>
                      <p><span className="paddingL33">I. You are entitled to the technical and information services provided by Lab Direct and to the technical support, consultation and other services provided by Lab Direct when accepting the services provided by Lab Direct. For details of service content, please refer to related product introduction on this Website.</span>
                      </p>
                      <p><span className="paddingL33">II. You warrant that you will not use any technical or other means to damage or disrupt this Website.</span>
                      </p>
                      <p><span className="paddingL33">III. You must use the products or services provided by Lab Direct in accordance with national laws, local regulations, industry practices, and public ethics and you will not use the products or services provided by Lab Direct to store, distribute, or disseminate the following information and content. At the same time, you are supposed to undertake not to provide any convenience for others to release the following information that is not in conformity with the national regulations and/or the terms of service.</span>
                      </p>
                      <p><span className="paddingL33">1. Any content (information) that violates national laws, regulations and policies.</span>
                      </p>
                      <p><span className="paddingL33">2. Political propaganda and/or information in violation of national regulations.</span>
                      </p>
                      <p><span
                        className="paddingL33">3. Information relating to national secrets and/or security.</span>
                      </p>
                      <p><span className="paddingL33">4. Feudal superstitions and/or obscenity, pornography, indecent information or abetting information.</span>
                      </p>
                      <p><span className="paddingL33">5. Any game of chance.</span></p>
                      <p><span className="paddingL33">6. Information in violation of the national ethnic and religious policies.</span>
                      </p>
                      <p><span
                        className="paddingL33">7. Information that interferes with the security of the Internet.</span>
                      </p>
                      <p><span className="paddingL33">8. Information or content that infringes upon the legitimate rights and interests of others and/or that is detrimental to social order, public security, and public morals.</span>
                      </p>
                      <p><span className="paddingL33 bold">Article V Lab Direct’s Rights and Obligations</span></p>
                      <p><span className="paddingL33">Lab Direct shall provide you with qualified technical and information services based on your choice of service and the circumstances in which payments are made. Lab Direct undertakes to keep the information you provide confidential and not to disclose it to third parties or authorize third parties to use your data, except in any of the following cases:</span>
                      </p>
                      <p><span className="paddingL33">1. It shall be provided in accordance with the terms of service or other service agreements, contracts, online terms, etc. between you and Lab Direct.</span>
                      </p>
                      <p><span className="paddingL33">2. It shall be provided in accordance with the provisions of laws and regulations.</span>
                      </p>
                      <p><span className="paddingL33">3. It shall be provided by Lab Direct to administrative, judicial and other competent authorities in accordance with the law.</span>
                      </p>
                      <p><span className="paddingL33">4. It shall be provided under the request from the shareholders, investors, and relevant stakeholders of Lab Direct.</span>
                      </p>
                      <p><span className="paddingL33">5. You agree that Lab Direct provides it to third parties.</span>
                      </p>
                      <p><span className="paddingL33">6. It shall be provided by Lab Direct in response to resolving reported incidents or filing a lawsuit.</span>
                      </p>
                      <p><span className="paddingL33">7. It shall be provided by Lab Direct to take necessary reasonable measures to prevent serious violations or suspected criminal acts.</span>
                      </p>
                      <p><span className="paddingL33">8. It shall be provided by Lab Direct to third parties to provide you with products, services, and information, including the circumstances under which Lab Direct provides you with products, services, and information through third-party technologies and services.</span>
                      </p>
                      <p><span className="paddingL33 bold">Article VI Renewal, Entry into Force and Performance of the Agreement</span>
                      </p>
                      <p><span className="paddingL33">I. Lab Direct reserves the right to amend the terms and conditions of this Agreement at any time in accordance with changes in national laws and regulations and the requirements of the website operation. The amended agreement shall become effective as soon as it is posted on this Website and supersedes the original agreement.</span>
                      </p>
                      <p><span className="paddingL33">II. In the event of any change in the terms of service of this Website, the changes will be prompted on important pages. If you do not agree to the updated agreement, you may and shall immediately cease to accept the services provided by this Website under this Agreement; and if you continue to use the services provided on this Website, you shall be deemed to agree to the updated agreement. Lab Direct recommends that you read this Agreement and the announcement of this Website before using this Website. If any Article of this Agreement is deemed to be annulled, invalid or unenforceable for any reason, it shall be deemed severable and shall not affect the validity and enforceability of any remaining provisions.</span>
                      </p>
                      <p><span className="paddingL33 bold">Article VII Ownership of Information Content</span></p>
                      <p><span className="paddingL33">The information content defined by this Website includes: text, software, sounds, photos, videos, graphics; all contents in advertisements; and other information provided by this Website for users. All of these contents are under protection of copyright, trademark, label, and other property ownership laws. Therefore, users can only use the content under the authority of this Website and advertisers, and cannot copy, reproduce the content, or create content-related derivative products.</span>
                      </p>
                      <p><span className="paddingL33 bold">Article VIII Application of Law and Jurisdiction</span></p>
                      <p><span className="paddingL33">The information service terms of this Website shall be consistent with the legal interpretation of the People's Republic of China. The user and this Website agree to submit to the jurisdiction of the court where this Website is located. In the event of a conflict between the terms of service of this Website and those of the laws of the People's Republic of China, these terms shall be reinterpreted in full accordance with the law while the other terms shall remain binding upon the user.</span>
                      </p>
                    </div>
                  </div>
                ) : showItemId === 'qyfwzz' ? (
                  <div className="right qyfwzz">
                    <h2>Corporate Service Qualification</h2>
                    <div className="clearfix">
                      <div className="cell">
                        <Image src={zzws}/>
                        <span>微松冷链授权资质</span>
                      </div>
                      <div className="cell">
                        <Image src={zzakm}/>
                        <span>澳柯玛授权资质</span>
                      </div>
                      <div className="cell">
                        <Image src={zzby}/>
                        <span>白洋医疗授权资质</span>
                      </div>
                    </div>
                  </div>
                ) : null
              }
            </div>
          </div>
        )
      }
    </div>
  )
})
